import _ from "lodash";
import { setUserInfoInReduxAndStorage } from "Login/modules/LoginModule";
import client from "lib/apolloClient/client";
import {
  updateUserProfileMutation,
  unlinkThirdPartyAccountMutation,
} from "./ProfileMutations";
import {
  getUserProfileDetailsFromCache,
  writeUserProfileDetailsToCache,
} from "./ProfileGraphqlHelpers";
import { USER_TYPE_ENTITY_MAPPING } from "Constants";
import ACLStore from "lib/aclStore";
// CONSTANTS

import {
  ENABLE_GOOGLE_DRIVE,
  ENABLE_ONE_DRIVE,
} from "Constants/permissionConstants";
import { getUserInfofromStorage } from "services/localStorage";

// ACTIONS CREATORS

export const updateUser = input => {
  return async (dispatch, getState) => {
    const userType = _.get(getState(), "login.userInfo.user_type");
    const userEntityType = _.get(
      USER_TYPE_ENTITY_MAPPING[userType],
      "entityType",
      ""
    );
    const cachedUserDetails = getUserProfileDetailsFromCache({
      id: input.id,
      type: userEntityType,
    });
    try {
      await client.mutate({
        mutation: updateUserProfileMutation,
        variables: {
          ...input,
        },
        update: (
          cache,
          {
            data: {
              platform: { updateUser },
            },
          }
        ) => {
          const data = {
            ...cachedUserDetails,
            ...updateUser,
          };
          writeUserProfileDetailsToCache({
            id: input.id,
            data,
          });

          const storageData = getUserInfofromStorage() || {};
          dispatch(
            setUserInfoInReduxAndStorage({
              ...storageData,
              first_name: data.firstName,
              last_name: data.lastName,
              email: data.email,
              profile_image: data.profileImage,
            })
          );
        },
        refetchQueries: [`getUserProfileDetails`],
      });
    } catch (error) {
      // console.log(error);
    }
  };
};

export const unlinkThirdPartyAccount = accountId => {
  return async (dispatch, getState) => {
    try {
      await client.mutate({
        mutation: unlinkThirdPartyAccountMutation,
        variables: {
          accountId,
        },
        refetchQueries: [`getUserProfileDetails`],
      });
    } catch (error) {
      // console.log(error);
    }
  };
};

export const getAccountTypes = ({ userType } = {}) => {
  return (dispatch, getState) => {
    const canLinkZoom = ACLStore.can("FeatureFlag:NewZoomAccountLinking");
    const canLinkGoogle = ACLStore.can(ENABLE_GOOGLE_DRIVE);
    const canLinkOneDrive = ACLStore.can(ENABLE_ONE_DRIVE);

    const accountTypes = [];

    if (canLinkZoom && userType === "staff") {
      accountTypes.push("ZOOM");
    }

    if (canLinkGoogle) {
      accountTypes.push("GOOGLE");
    }

    if (canLinkOneDrive) {
      accountTypes.push("MICROSOFT");
    }

    return accountTypes;
  };
};

// REDUCER_HANDLERS
const REDUCER_HANDLERS = {};

const initialState = {};

export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
